import React from 'react';
import { Card } from '@ncoder/ui';
import { HealthCheckItem } from '../../atoms/deployment';

interface HealthCheck {
  service: string;
  status: 'healthy' | 'warning' | 'critical';
  responseTime: string;
  lastChecked: string;
}

interface HealthCheckPanelProps {
  healthChecks: HealthCheck[];
}

export const HealthCheckPanel: React.FC<HealthCheckPanelProps> = ({
  healthChecks,
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Health Checks</h3>
      <div className="space-y-4">
        {healthChecks.map((check) => (
          <HealthCheckItem
            key={check.service}
            service={check.service}
            status={check.status}
            responseTime={check.responseTime}
            lastChecked={check.lastChecked}
          />
        ))}
      </div>
    </Card>
  );
};
